class NotificationWrapper extends HTMLElement {
    
    constructor() {
        super();
        
        this.messageContainer = this.querySelector('[data-messages]');
        this.messageQueue = new NotificationMessageQueue();
        
        this.init();
    }
    
    init() {
        this.messageQueue.getMessages().forEach(message => {
            this.messageContainer.insertAdjacentHTML('beforeend', '<p>'+message.message+'</p>');
        });
        this.messageQueue.clear();
    }
}

customElements.define('notification-wrapper', NotificationWrapper);